var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import 'i18next';
import { BasePartner, } from '../BasePartner';
import { buildCareCardFromCareOption, buildCareCardFromPropsObject, buildCareCardButtons, } from '../../../CareCard/CareCardBuilder';
import '../../../../clearstep/Types';
import { SourceOfCare } from '../../../../clearstep/proto/results_pb';
import { SpecialistCareDetail } from '../../../../../util/care_details/SpecialistCareDetail';
import { optionWithCareDetailCard } from '../CareDetails';
import { HomeCareFindPharmacyIcon } from '../../../../svg/HomeCareFindPharmacyIcon';
import { StethoscopeCircleIcon } from '../../../../svg/StethoscopeCircleIcon';
import '../../../CareCard/CareCard';
import { InPersonPrimaryCare, SameDayPrimaryCare, UrgentCare, VirtualUrgentCare, } from './OchsnerCareCardIcons';
import SectionHeader from '../../../../clearstep/SectionHeader/SectionHeader';
import { DisclaimerText } from '../../../DisclaimerText/DisclaimerText';
import PartnerCareLocation from '../../../PartnerCareLocation/PartnerCareLocation';
import '../../../../clearstep/proto/care_locations_pb';
import Button from '../../../../tailwind_common/Button';
import { MessageType } from '../../../../clearstep/proto/logging_pb';
import { linkToAndLog } from '../../../../../util/EventLog';
import { THEME } from '../../../../clearstep/util/Theme';
import FindCarePlaceholder from '../../../../tailwind_common/FindCarePlaceholder';
import { PartnerCustomizationContext } from '../PartnerCustomizations';
import { useIsEnabled } from '../../../../clearstep/util/Split';
import { CovidInformationCareDetailDescriptor } from '../../../../../util/care_details/CovidInformationCareDetail';
var OchsnerSpecialistDescription = 'Ochsner has a range of experienced specialists who can provide a personalized treatment plan for you. Our teams use the latest techniques and technology to help you get back to doing what you love.';
var OchsnerSpecialistCTA = 'Schedule Appointment';
var isSameDayCapacity = function (careDetails) {
    return careDetails === null || careDetails === void 0 ? void 0 : careDetails.includes('has-primary-care-same-day-capacity');
};
var specialistCustomizations = (_a = {},
    _a[SpecialistCareDetail.CLINICAL_PSYCHOLOGIST] = {
        description: 'Ochsner has a range of experienced specialists who can provide a personalized treatment plan for you. Our teams use the latest techniques and technology to help you get back to doing what you love. Please call 1-866-624-7637 to schedule an appointment.',
    },
    _a[SpecialistCareDetail.THERAPIST] = {
        description: 'Ochsner has a range of experienced specialists who can provide a personalized treatment plan for you. Our teams use the latest techniques and technology to help you get back to doing what you love. Please call 1-866-624-7637 to schedule an appointment.',
    },
    _a[SpecialistCareDetail.CARDIOLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Cardiology%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.DENTISTRY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://ochsner.org/locations?q=&specialty=dentistry',
            },
        ],
    },
    _a[SpecialistCareDetail.DERMATOLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Dermatology"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.PEDIATRICS] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://ochsner.org/locations?q=&specialty=pediatrics',
            },
        ],
    },
    _a[SpecialistCareDetail.GASTROENTEROLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Gastroenterology"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.NEUROLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Neurology"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.OBGYN] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Obstetrics+and+Gynecology"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.OPHTHALMOLOGIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"taxonomy_relatedSpecialties.name"%3A%5B"Ophthalmology"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.FOOT_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Foot+and+Ankle+Orthopedic+Surgery"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.ANKLE_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://ochsner.org/locations?q=&specialty=ankle_specialist',
            },
        ],
    },
    _a[SpecialistCareDetail.GENERAL_ORTHOPEDIC] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Orthopedic+Surgery"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.HAND_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Hand+Surgery%22%2C%22Shoulder%2C+Elbow+and+Hand+Orthopedic+Surgery%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.WRIST_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://ochsner.org/locations?q=&specialty=wrist_specialist',
            },
        ],
    },
    _a[SpecialistCareDetail.HIP_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Hip+and+Knee+Orthopedic+Surgery"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.KNEE_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B"c_activateScheduleNow"%3A%5Btrue%5D%2C"taxonomy_relatedSpecialties.name"%3A%5B"Hip+and+Knee+Orthopedic+Surgery"%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.SHOULDER_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Shoulder%2C+Elbow+and+Hand+Orthopedic+Surgery%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.SPINE_SPECIALIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Spinal+Surgery%22%2C%22Spine+Orthopedics%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.ENT] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Otolaryngology+%28ENT+-+Ear%2C+Nose+and+Throat%29%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.OTOLARYNGOLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Otolaryngology%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.PULMONOLOGIST] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Pulmonology%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.UROLOGY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Urology%22%5D%7D',
            },
        ],
    },
    _a[SpecialistCareDetail.PODIATRY] = {
        description: OchsnerSpecialistDescription,
        buttons: [
            {
                cta: OchsnerSpecialistCTA,
                url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22taxonomy_relatedSpecialties.name%22%3A%5B%22Podiatry%22%5D%7D',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_VACCINE_INFORMATION] = {
        title: 'COVID-19 Vaccine Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.ochsner.org/coronavirus',
            },
        ],
    },
    _a[CovidInformationCareDetailDescriptor.COVID_19_TESTING_INFORMATION] = {
        title: 'COVID-19 Testing Information',
        buttons: [
            {
                cta: 'See more information',
                url: 'https://www.ochsner.org/coronavirus',
            },
        ],
    },
    _a);
var OchsnerPartner = /** @class */ (function (_super) {
    __extends(OchsnerPartner, _super);
    function OchsnerPartner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.behavioralHealthOption = function (options) {
            var behavioralHealthOption = options.behavioralHealthOption;
            return behavioralHealthOption
                ? buildCareCardFromPropsObject({
                    title: behavioralHealthOption.subtitle,
                    useMarkdown: behavioralHealthOption.isMarkdown,
                    heading: behavioralHealthOption.heading,
                    buttons: buildCareCardButtons(behavioralHealthOption.buttons),
                    noMargin: true,
                })
                : null;
        };
        return _this;
    }
    OchsnerPartner.prototype.careOptionDescription = function (options) {
        var careTypeList = [
            SourceOfCare.Type.PRIMARY_CARE,
            SourceOfCare.Type.ASYNCH_CARE,
            SourceOfCare.Type.TELEMEDICINE,
            SourceOfCare.Type.SPECIALIST,
            SourceOfCare.Type.AMBULANCE,
            SourceOfCare.Type.POISON_CONTROL,
            SourceOfCare.Type.HOME,
        ];
        if (careTypeList.includes(options.careType)) {
            return React.createElement(React.Fragment, null);
        }
        if (options.careType === SourceOfCare.Type.URGENT_CARE) {
            return options.sourceOfCare ? buildCareCardFromCareOption(options.sourceOfCare) : null;
        }
        return null;
    };
    OchsnerPartner.prototype.careOptionCost = function (options) {
        var careType = options.careType;
        if (careType === SourceOfCare.Type.URGENT_CARE) {
            return 2;
        }
        return null;
    };
    OchsnerPartner.prototype.partnerOptionWithCareDetail = function (options) {
        return optionWithCareDetailCard(options.careDetails || [], specialistCustomizations);
    };
    OchsnerPartner.prototype.getPharmacyCardCustomizations = function () {
        var t = useTranslation().t;
        return {
            title: t('careCards.findPharmacy.title', 'Find a pharmacy'),
            description: t('ochsner.findPharmacy.description', 'If you need fever, pain medications or other over-the-counter medications, ask someone who is healthy to pick them up from a pharmacy.'),
            icon: React.createElement(HomeCareFindPharmacyIcon, null),
        };
    };
    OchsnerPartner.prototype.getUrgentCareCardCustomizations = function () {
        return {
            findOtherLocationsUrl: 'https://search.ochsner.org/?verticalKey=locations&facets=%7B%22c_locationType%22%3A%5B%22urgent+care+center%22%5D%7D',
        };
    };
    OchsnerPartner.prototype.homeCareProviderOption = function (options) {
        var homeCareOption = options.homeCareOption;
        return homeCareOption ? buildCareCardFromCareOption(homeCareOption) : null;
    };
    OchsnerPartner.prototype.virtualVisitOptions = function (soc) {
        return soc ? buildCareCardFromCareOption(soc) : null;
    };
    OchsnerPartner.prototype.careOptionTitle = function (options) {
        // If there is exactly one Specialist Type, we should replace the Specialist title with the specific Specialist
        if ((options === null || options === void 0 ? void 0 : options.careType) === SourceOfCare.Type.SPECIALIST) {
            return this.getSpecialistTitle(options.careDetails, options.title);
        }
        if ((options === null || options === void 0 ? void 0 : options.careType) === SourceOfCare.Type.PRIMARY_CARE &&
            isSameDayCapacity(options === null || options === void 0 ? void 0 : options.careDetails)) {
            return 'Same-Day Primary Care';
        }
        return options.title;
    };
    OchsnerPartner.prototype.primaryCareOption = function (options) {
        var partnerCustomizations = useContext(PartnerCustomizationContext);
        var _a = options || {}, careDetails = _a.careDetails, careLocations = _a.careLocations, numberOfCareLocations = _a.numberOfCareLocations, isLoading = _a.isLoading, careType = _a.careType, setZipFocus = _a.setZipFocus;
        var enableScheduling = useIsEnabled('ochsner_epic_scheduling') === 'on';
        if (options && isSameDayCapacity(careDetails)) {
            options.description =
                "Schedule a virtual or in-office same-day appointment with a primary care doctor in Ochsner's network. If you think you need hands-on examination to better diagnose your issue, choose the in-person option. The primary care physician or provider you see can connect you with specialized doctors in Ochsner's network if you need additional care.";
            options.buttons = [
                {
                    text: '',
                    clickEventName: '',
                    cta: 'Schedule Same-Day Care',
                    hasMarginTop: true,
                    heading: 'p',
                    url: 'https://www.ochsner.org/scheduling-landing-page#same-day-scheduling-widget',
                    useWhitespace: false,
                },
                {
                    text: '',
                    clickEventName: '',
                    cta: 'Find a Doctor',
                    hasMarginTop: true,
                    heading: 'p',
                    url: 'https://doctors.ochsner.org/?verticalKey=healthcare_professionals&facets=%7B%22c_activateScheduleNow%22%3A%5Btrue%5D%2C%22taxonomy_relatedSpecialties.name%22%3A%5B%22Family+Medicine%22%2C%22Primary+Care+%28Internal+Medicine%29%22%5D%7D',
                    useWhitespace: false,
                },
            ];
            return React.createElement(React.Fragment, null, buildCareCardFromCareOption(options));
        }
        if (enableScheduling) {
            return (React.createElement("div", null,
                buildCareCardFromCareOption(__assign(__assign({}, options), { buttons: [] }), undefined, Array.isArray(careLocations) && !!careLocations.length),
                React.createElement("br", null),
                React.createElement("br", null),
                Array.isArray(careLocations) && !!careLocations.length ? (careLocations
                    .slice(0, numberOfCareLocations !== null && numberOfCareLocations !== void 0 ? numberOfCareLocations : 5)
                    .map(function (careLocation) { return (React.createElement(PartnerCareLocation, { location: careLocation, key: careLocation.name, includePhysicianImage: true, defaultImageIcon: "/static/images/partners/ochsner/doc-placeholder.png", imgClassName: "w-full", ctaForName: true, openCtaInNewTab: true })); })) : (React.createElement(FindCarePlaceholder, { text: partnerCustomizations.findCarePlaceholderText(careType || SourceOfCare.Type.UNKNOWN), loadingCareLocation: isLoading ? isLoading() : false, setZipFocus: setZipFocus, wrapperClassName: "mb-0" }))));
        }
        return options ? buildCareCardFromCareOption(options) : null;
    };
    OchsnerPartner.prototype.schedulingLinkConfig = function (location) {
        var careType = location.careType, link = location.link;
        if (!link) {
            return null;
        }
        var buttonText = careType === SourceOfCare.Type.PRIMARY_CARE
            ? 'View Profile'
            : careType === SourceOfCare.Type.URGENT_CARE
                ? 'Schedule at Location'
                : 'Book Now!';
        window.onpopstate = function (event) {
            if (event.state && event.state.previousUrl) {
                window.location.href = event.state.previousUrl;
            }
        };
        return {
            schedulingLinkImg: (React.createElement(Button, { alternative: true, onClick: function () {
                    linkToAndLog(link, MessageType.CLICKED_PARTNER_CARE_OPTION, { data: { text: buttonText } }, { partner: THEME.partner });
                } }, buttonText)),
            schedulingLink: link,
        };
    };
    OchsnerPartner.prototype.getERCardCustomizations = function () {
        return {
            title: 'Find a hospital near you',
            description: 'Emergency medicine doctors can help with sudden or life-threatening situations.',
            icon: React.createElement(StethoscopeCircleIcon, null),
        };
    };
    OchsnerPartner.prototype.careOptionIcon = function (careType, careDetails) {
        switch (careType) {
            case SourceOfCare.Type.TELEMEDICINE:
                return React.createElement(VirtualUrgentCare, null);
            case SourceOfCare.Type.PRIMARY_CARE:
                if (isSameDayCapacity(careDetails)) {
                    return React.createElement(SameDayPrimaryCare, null);
                }
                return React.createElement(InPersonPrimaryCare, null);
            case SourceOfCare.Type.URGENT_CARE:
                return React.createElement(UrgentCare, null);
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    // disclaimer() not used for partners that need translation
    // so we can disable jsx-no-literals for now
    OchsnerPartner.prototype.disclaimer = function () {
        var t = useTranslation().t;
        return (React.createElement("div", { className: "pt-10" },
            React.createElement(SectionHeader, { text: t('common.disclaimerTitleTitleCase', 'Disclaimer & Acknowledgment') }),
            React.createElement(DisclaimerText, null),
            React.createElement(Trans, { t: t, i18nKey: "basePartner.disclaimerLink" },
                React.createElement("div", { className: "pb-4 text-xs font-medium text-dark-gray" },
                    "View",
                    ' ',
                    React.createElement("a", { className: "inline-flex items-center font-semibold text-primary no-underline hover:underline", href: "https://www.clearstep.health/terms-and-conditions", target: "_blank", rel: "noopener noreferrer" }, "full terms"),
                    "."))));
    };
    OchsnerPartner.prototype.searchCareLocationDefaults = function (_triageResponse) {
        return {
            sort: 'soonest_availability',
            findNextAvailableSlot: true,
        };
    };
    OchsnerPartner.prototype.headerLogoLink = function () {
        return {
            newTab: true,
        };
    };
    return OchsnerPartner;
}(BasePartner));
export { OchsnerPartner };
